const DOCUMENT = 'ADD_NEW_PRICE_LIST_BULK_MARKUP_';

const actions = {
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  SHOW_MODAL: DOCUMENT + 'SHOW_MODAL',
  CLOSE_MODAL: DOCUMENT + 'CLOSE_MODAL',
  CLEAR_VALUE: DOCUMENT + 'CLEAR_VALUE',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  showModal: () => ({
    type: actions.SHOW_MODAL,
  }),

  closeModal: () => ({
    type: actions.CLOSE_MODAL,
  }),

  clearValue: () => ({
    type: actions.CLEAR_VALUE,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
